import * as z from 'zod';
import { CURRENCY } from 'src/types';
import { FINANCIAL_DOCUMENT_TYPE } from 'src/features/financialDocuments/utils/types';
import { validationMessagesMap } from 'src/utils/messages';

export type FinancialDocumentFormSchemaValues = z.infer<typeof financialDocumentFormSchema>;
export const financialDocumentFormSchema = z
    .object({
        type: z.enum(FINANCIAL_DOCUMENT_TYPE),
        accounting_range: z.string().optional().nullable(),
        currency: z.enum(CURRENCY),
        public_description: z.string().optional().nullable(),
        internal_description: z.string().optional().nullable(),
        tax_event_date: z.string().optional().nullable(),
        payment_due_date: z.string().optional().nullable(),
        issue_due_date: z.string().optional().nullable(),
        supplier: z.string(),
        customer: z.string().nonempty(),
        financial_document: z.string().optional().nullable(),
        number: z.string().optional().nullable(),
    })
    .superRefine((data, ctx) => {
        if (
            (data.type === FINANCIAL_DOCUMENT_TYPE.CREDIT_NOTE || data.type === FINANCIAL_DOCUMENT_TYPE.DEBIT_NOTE) &&
            !data.financial_document
        ) {
            ctx.addIssue({
                path: ['financial_document'],
                message: validationMessagesMap.validationErrorRequired,
                code: 'custom',
            });
        }
    });

export type EditDraftFinancialDocumentFormSchemaValues = z.infer<typeof editDraftFinancialDocumentSchema>;
export const editDraftFinancialDocumentSchema = financialDocumentFormSchema.partial().extend({
    currency: z.enum(CURRENCY),
    supplier: z.string(),
    customer: z.string(),
});

export type PatchFinancialDocumentFormSchemaValues = z.infer<typeof patchFinancialDocumentSchema>;
export const patchFinancialDocumentSchema = financialDocumentFormSchema.partial().extend({
    public_description: z.string().optional().nullable(),
    internal_description: z.string().optional().nullable(),
});
